import { render, staticRenderFns } from "./contentCategoryRecycle.vue?vue&type=template&id=5926ddfa&"
import script from "./contentCategoryRecycle.vue?vue&type=script&lang=js&"
export * from "./contentCategoryRecycle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports